import PieChartOptionsViewModel from "../../TripRate/ViewModels/PieChartOptionsViewModel";

export default class ExportChartViewModel {
    addUserComments: boolean = false;
    fileName: string = "Modal Split Pie";
    userComments: string = "";
    displayPDFtoScreen: boolean = false;
    type: string = "PDF";
    data: PieSegment[] = [];
    surveyRef: string | null = null;
    surveyDate: string | null = null;
    options: PieChartOptionsViewModel = new PieChartOptionsViewModel();
    chartTitle: string | null = null;
}
